import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { constants } from 'app/constants';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MasterGroupService {

  masterList : any = {};

  constructor(
    private http: HttpClient
  ) { }

  createForm() {
    return new UntypedFormGroup({
      'name': new UntypedFormControl('', Validators.required),
      'area': new UntypedFormControl('', Validators.required),
      'state_id': new UntypedFormControl('', Validators.required),
      'pincode': new UntypedFormControl(''),
      'contactNo': new UntypedFormControl('', Validators.required),
      'emailId': new UntypedFormControl(''),
    });
  }

  createCustomerForm() {
    return new UntypedFormGroup({
      'partyName': new UntypedFormControl('', Validators.required),
      'ownerName': new UntypedFormControl('', Validators.required),
      'address': new UntypedFormControl('', Validators.required),
      'area': new UntypedFormControl('', Validators.required),
      'district': new UntypedFormControl(''),
      'state_id': new UntypedFormControl('', Validators.required),
      'pincode': new UntypedFormControl('', Validators.required),
      'shipping': new UntypedFormControl('', Validators.required),
      'gstNo': new UntypedFormControl('', Validators.required),
      'contactNo': new UntypedFormControl('', Validators.required),
      'emailId': new UntypedFormControl(''),
      'panNo': new UntypedFormControl(''),
      'cgstInCent': new UntypedFormControl(''),
      'igstInCent': new UntypedFormControl(''),
      'discountInCent': new UntypedFormControl(''),
      'agent': new UntypedFormControl('', Validators.required),
      'notes': new UntypedFormControl('')
    });
  }

  getAllListApi(url: string, data: any = {}) {
    return new Promise((resolve, reject) => {
      if (url in this.masterList && (!data.hasOwnProperty('limit'))) {
        resolve(this.masterList[url]);
        return;
      }
      const endpointUrl = environment.host_api + url + '/';
      this.http.request('GET', endpointUrl, {params: data})
      .subscribe(
        response => {
          if (response) {
            console.log('All ' + url + ' Details Received......');
            this.masterList[url] = response;
            resolve(response);
          }
        },
        error => {
          console.log(error.error);
          reject(error.error);
        }
      );
    });
  }

  addUpdateDetailsApi(formGroup: UntypedFormGroup, url: string, requestMethod: string, data: any = {}) {
    return new Promise((resolve, reject) => {
      const endpointUrl = environment.host_api + url + '/';
      
      if (requestMethod !== 'DELETE') {
        data = this.getDataFromForm(formGroup, data, url);
      }
      if (!data) {
        return reject();
      }

      this.http.request(requestMethod, endpointUrl, {body: data})
      .subscribe(
        response => {
          console.log(url + ' Details Addeddd......');
          resolve(response);
        },
        error => {
          console.log(error.error);
          reject(error.error);
        }
      );
    });
  }

  getDataFromForm(formGroup: UntypedFormGroup, data: any, url: string) {
    data['user_id'] = sessionStorage.getItem('user_id');
    data['area'] = formGroup.get('area')?.value;
    data['district'] = formGroup.get('district')?.value;
    data['state_id'] = formGroup.get('state_id')?.value;
    data['pincode'] = formGroup.get('pincode')?.value;
    data['contact_no'] = formGroup.get('contactNo')?.value;
    data['email_id'] = formGroup.get('emailId')?.value;

    if (!url.includes('customer')) {
      data['name'] = formGroup.get('name')?.value;
      return data;
    }
    
    data['party_name'] = formGroup.get('partyName')?.value;
    data['owner_name'] = formGroup.get('ownerName')?.value;
    data['address'] = formGroup.get('address')?.value;
    data['shipping_id'] = formGroup.get('shipping')?.value;
    data['gst_no'] = formGroup.get('gstNo')?.value;
    data['pan_no'] = formGroup.get('panNo')?.value;
    data['cgst_in_cent'] = formGroup.get('cgstInCent')?.value || 0;
    data['igst_in_cent'] = formGroup.get('igstInCent')?.value || 0;
    data['discount_in_cent'] = formGroup.get('discountInCent')?.value || 0;
    data['agent_id'] = formGroup.get('agent')?.value;
    data['notes'] = formGroup.get('notes')?.value;
    return data;
  }

  getSelectedCustomerInGrid(selectedRow: any, customerList: any) {
    for (let i = 0; i < customerList.length; i++) {
      if (selectedRow['customer_id'] === customerList[i]['id']) {
        return customerList[i];
      }
    }
    return null;
  }

  addUpdateLabelDetails(data: any, requestMethod: string) {
    return new Promise((resolve, reject) => {
      const endpointUrl = environment.host_api + 'label_details/';

      data['user_id'] = sessionStorage.getItem('user_id');
    
      this.http.request(requestMethod, endpointUrl, {body: data})
      .subscribe(
        response => {
          console.log('Successfully udpated Label Details');
          resolve(response);
        },
        error => {
          console.log(error.error);
          reject(error.error);
        }
      )
    })
  }
}
